export default __webpack_public_path__ + "static/analytics-b09b84604d7b05a71f310166285efc4f.png";